





































































import Vue from 'vue'
import _ from 'lodash'
import {
  GET_SELECTED_UI_LANGUAGE, PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS_LIST,
  PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE,
  PLANNING_ASSISTANT_GET_PERIODICITY, PLANNING_ASSISTANT_GET_START_DATE
} from '@/store/getter-types'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'
import { AdditionalGroup } from '@/model/additional-fields/AdditionalGroup'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'
import {
  FETCH_PROJECT_ADDITIONAL, PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS
} from '@/store/action-types'
import Select from '@/components/additional-fields/AdditionalFieldsSelect.vue'
import NumberField from '@/components/additional-fields/AdditionalFieldsNumber.vue'
import FieldsText from '@/components/additional-fields/AdditionalFieldsText.vue'
import Check from '@/components/additional-fields/AdditionalFieldsCheck.vue'
import Textarea from '@/components/additional-fields/AdditionalFieldsTextArea.vue'
import Email from '@/components/additional-fields/AdditionalFieldsEmail.vue'
import FieldsDatePicker from '@/components/additional-fields/AdditionalFieldsDatePicker.vue'
import SelectMultiple from '@/components/additional-fields/AdditionalFieldsSelectMultiple.vue'
import { AdditionalFieldsPayloadItem, PlanningAssistantPeriodicityPayload } from '@/types/payload'
import moment from 'moment'
import { EditShiftPlan } from '@/model/planning/EditShiftPlan'
import { mapGetters } from 'vuex'
import DecimalNumber from '@/components/additional-fields/AdditionalFieldsDecimalNumber.vue'

interface EditableEmployee {
  id: number | undefined,
  name: string | undefined,
  number: number | undefined,
  taskId: number | undefined,
  taskName: string | undefined,
  note: string | undefined,
  isPlaceholder: boolean
}

interface ComponentData {
  active: number[]
  treeItemList: AdditionalGroup[]
  componentTypeMap: Map<number, string>
  selectedData: AdditionalFieldItem[]
  editableEmployeeList: EditableEmployee[] | any
  panel: number[]
}

export default Vue.extend({
  name: 'ShiftEditorAdditionalFields',

  components: {
    Select,
    NumberField,
    FieldsText,
    Check,
    Textarea,
    Email,
    FieldsDatePicker,
    SelectMultiple,
    DecimalNumber
  },

  props: {
    editShift: Object as () => EditShiftPlan | undefined
  },

  data (): ComponentData {
    return {
      active: [],
      treeItemList: [],
      componentTypeMap: new Map([
        [2, 'Select'], [4, 'DecimalNumber'], [1, 'FieldsText'], [21, 'Textarea'], [3, 'Check'], [6, 'Email'], [11, 'FieldsDatePicker'], [5, 'SelectMultiple']
      ]),
      selectedData: [],
      editableEmployeeList: [],
      panel: [0]
    }
  },

  computed: {
    ...mapGetters([PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS_LIST]),

    periodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[PLANNING_ASSISTANT_GET_PERIODICITY]
    },

    isEdittingSerie (): boolean {
      return this.$store.getters[PLANNING_ASSISTANT_GET_IS_EDITTING_SERIE]
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    getDates (): string[] {
      return _.uniqBy(this.treeItemList, 'date').map((item: AdditionalGroup) => {return item.date}).sort()
    },

    dateStart (): Date {
      return this.$store.getters[PLANNING_ASSISTANT_GET_START_DATE]
    },

    filterTreeItemList (): AdditionalGroup[] {
      if(this.treeItemList) {
        return this.treeItemList ? this.treeItemList.filter((item: AdditionalGroup) => moment(item.date).format('DD.MM.YYYY') === moment(this.dateStart).format('DD.MM.YYYY')) : []
      } else {
        return this.treeItemList ? this.treeItemList : []
      }
    }
  },

  watch: {
    [PLANNING_ASSISTANT_GET_ADDITIONAL_FIELDS_LIST] (newVal: AdditionalGroup[]): void {
      if(newVal) {
        this.treeItemList = newVal
      }
    }
  },

  methods: {
    formattedDate (date: string): string {
      return moment(date).locale(this.selectedLanguage).format('DD.MM.YYYY - dddd')
    },

    filteredTreeItemList (date: string): AdditionalGroup[] {
      if(this.treeItemList) {
        return this.treeItemList.filter((item: AdditionalGroup) => item.date === date)
      } else {
        return []
      }
    },

    onValueChange (data: AdditionalFieldItem): void {
      const foundData: AdditionalFieldItem | undefined = this.selectedData.find((item: AdditionalFieldItem) => item.parentType === data.parentType && item.project === data.project)
      if(foundData) {
        const index: number = this.selectedData.indexOf(foundData)
        this.selectedData.splice(index, 1, data)
      } else {
        this.selectedData.push(data)
      }

      if(this.treeItemList) {
        this.treeItemList.forEach((group: AdditionalGroup) => {
          if (group.id === data.groupId && group.project === data.project) {
            group.children.forEach((field: AdditionalField, idx: number) => {
              if (field.type === data.parentType) {
                const updatedField: AdditionalField = AdditionalField.updateValue(field, data.value)
                group.children.splice(idx, 1, updatedField)
              }
            })
          }
        })
      }

      const fields: AdditionalFieldsPayloadItem[] = this.selectedData.map((item: AdditionalFieldItem) => {
        const foundGroup: AdditionalGroup | undefined = this.treeItemList.find((group: AdditionalGroup) => group.id === item.groupId && group.project === item.project)
        return {"Projekt": foundGroup ? foundGroup.project : null, "Feldtyp": item.parentType, "Art": item.componentId, "Value": item.value}
      })

      this.$store.dispatch(PLANNING_ASSISTANT_SET_ADDITIONAL_FIELDS, fields)
    },

    async fetchAdditionalData (): Promise<void> {
      if(!this.editShift) {
        //const payload: number | null = this.editShift ? this.editShift.projectSerieId : null
        this.treeItemList = await this.$store.dispatch(FETCH_PROJECT_ADDITIONAL, null)
      }
    }
  },

  mounted () {
    this.fetchAdditionalData()
  }

})
